import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {editSaveProblem, getProblem, messageReset} from "../store/problems";
import {TextareaAutosize} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import ReplyIcon from "@mui/icons-material/Reply";

function EditProblem(props) {
    const navigate = useNavigate()
    const params = useParams()
    const {t, i18n} = useTranslation()
    const [regionId, setRegionId] = useState(false)
    useEffect(() => {
        setRegionId(params.id)
    }, [params.id])
    const toBack = () => {
        navigate(-1);
    }
    const is_main = JSON.parse(localStorage.getItem('is_main'));
    const is_other = Boolean(props.current_user?.is_other) || JSON.parse(localStorage.getItem('is_other') || 'false');
    const [problem_title, setProblemTitle] = useState('')
    const [problem_text, setProblemText] = useState('')
    const [problem_date, setProblemDate] = useState('')
    const [problem_answer, setProblemAnswer] = useState('')
    const [answer_date, setAnswerDate] = useState('')
    const [openModal, setOpenModal] = useState(false)
    const [answerInput, setAnswerInput] = useState('')

    useEffect(() => {
        props.getProblem(params.id)
    }, [])

    useEffect(() => {
        setProblemTitle(props.problem_single.title)
        setProblemText(props.problem_single.text)
        setProblemAnswer(props.problem_single.answer || '')
        if (props.problem_single.answer_date) {
            let ad = new Date(props.problem_single.answer_date)
            setAnswerDate(
                String(ad.getDate()).padStart(2,'0') + '.' +
                String(ad.getMonth()+1).padStart(2,'0') + '.' +
                ad.getFullYear() + ' ' +
                String(ad.getHours()).padStart(2,'0') + ':' +
                String(ad.getMinutes()).padStart(2,'0')
            )
        }
        let newDate = new Date(props.problem_single.modified)
        let date = newDate.getDate();
        date = date<10 ? "0"+date : date
        let month = newDate.getMonth()+1;
        month = month<10 ? "0"+month : month
        let year = newDate.getFullYear();
        let hours = newDate.getHours();
        let minutes = newDate.getMinutes();
        let seconds = newDate.getSeconds();
        setProblemDate(date + "." + month + "." + year + "\t" + hours + ":" + minutes + ":" + seconds)
    }, [props.problem_single])

    function saveFormData(e) {
        e.preventDefault()
        const data = {
            "id": params.id,
            "title": problem_title,
            "text": problem_text,
        }
        props.editSaveProblem(data)
    }

    function saveAnswer() {
        if (!answerInput.trim()) {
            toast.error(t('fill_required') || "Javobni kiriting", {theme: 'colored'})
            return
        }
        const data = {
            "id": params.id,
            "title": problem_title,
            "text": problem_text,
            "answer": answerInput,
        }
        props.editSaveProblem(data)
        setOpenModal(false)
    }

    useEffect(() => {
        if (props.message === true) {
            toast.success(t('save_success') || "Javob saqlandi", {theme: 'colored'})
            props.messageReset()
            props.getProblem(params.id)  // javob saqlanib qayta yuklanadi
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return <div>
        <div className={'page'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon/>} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <h2 className={'page-title text-center'}>{t('change_info')}</h2>
                    <form className={'add-form add-document'} onSubmit={saveFormData}>
                        <p>
                            <span>{t('problem_title')}:</span>
                            <TextField
                                value={problem_title}
                                onChange={(e) => setProblemTitle(e.target.value)}
                                required
                                type={"text"}
                                variant="outlined"
                                disabled
                            />
                        </p>
                        <p>
                            <span>{t('problem_text')}:</span>
                            <TextareaAutosize
                                minRows={6}
                                placeholder={t('problem_text')}
                                value={problem_text}
                                required
                                onChange={(e) => setProblemText(e.target.value)}
                                variant="outlined"
                                disabled
                            />
                        </p>
                        <p>
                            <span>{t('problem_date')}:</span>
                            <TextField
                                value={problem_date}
                                type={"text"}
                                variant="outlined"
                                disabled
                            />
                        </p>
                        {/* Mavjud javob ko'rsatish */}
                        {problem_answer ? <p>
                            <span>{t('problem_answer') || "Javob"}:</span>
                            <TextareaAutosize
                                minRows={3}
                                value={problem_answer}
                                variant="outlined"
                                disabled
                            />
                        </p> : ''}
                        {problem_answer && answer_date ? <p>
                            <span>{t('answer_date') || "Javob vaqti"}:</span>
                            <TextField value={answer_date} variant="outlined" disabled/>
                        </p> : ''}
                        {/* Javob yozish tugmasi — faqat javob YO'Q bo'lganda */}
                        {!problem_answer &&
                        ((is_other && props.problem_single?.user?.is_district) ||
                            (is_main && props.problem_single?.user?.is_other &&
                                !props.problem_single?.user?.is_main)) ? <Button
                            variant="contained"
                            color="success"
                            startIcon={<ReplyIcon/>}
                            onClick={() => { setAnswerInput(problem_answer); setOpenModal(true) }}
                            style={{marginTop: '16px'}}
                        >
                            {problem_answer
                                ? (t('edit_answer') || "Javobni tahrirlash")
                                : (t('write_answer') || "Javob yozish")}
                        </Button> : ''}
                    </form>

                    {/* Javob yozish modali */}
                    <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="md">
                        <DialogTitle>{t('write_answer') || "Javob yozish"}</DialogTitle>
                        <DialogContent>
                            <TextareaAutosize
                                minRows={6}
                                style={{width: '100%', padding: '12px', fontSize: '14px'}}
                                placeholder={t('write_answer') || "Javobingizni yozing..."}
                                value={answerInput}
                                onChange={(e) => setAnswerInput(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => setOpenModal(false)} color="inherit">
                                {t('cancel') || "Bekor qilish"}
                            </Button>
                            <Button onClick={saveAnswer} variant="contained" color="success">
                                {t('save') || "Saqlash"}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => ({...props.problems, current_user: props.login?.user}), {
    getProblem,
    editSaveProblem,
    getAllVerifyResponse,
    messageReset
})(EditProblem)